import { p as palette } from '../base/color-ec580bc4.js';

const pageLayout = {
  section: {
    background: {
      default: palette.gray[0],
      offset: palette.gray[25]
    },
    contentMaxWidth: {
      xsmall: '320px',
      small: '540px',
      base: '960px',
      large: '1320px',
      fluid: '100%'
    }
  }
};
var pageLayout$1 = pageLayout;

export { pageLayout$1 as p };
//# sourceMappingURL=pageLayout-35eddb83.js.map
